var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2291_2262)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5638 0C14.9157 0.00195719 12.7726 2.15095 12.7746 4.79902C12.7726 7.44709 14.9177 9.59609 17.5658 9.59804H22.3569V4.80098C22.3589 2.15291 20.2138 0.00391437 17.5638 0C17.5658 0 17.5658 0 17.5638 0ZM17.5638 12.8H4.7912C2.14312 12.802 -0.00195184 14.9509 5.34875e-06 17.599C-0.00390902 20.2471 2.14117 22.3961 4.78924 22.4H17.5638C20.2119 22.398 22.3569 20.2491 22.355 17.601C22.3569 14.9509 20.2119 12.802 17.5638 12.8Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9041 17.599C47.906 14.9509 45.761 12.802 43.1129 12.8C40.4648 12.802 38.3197 14.9509 38.3217 17.599V22.4H43.1129C45.761 22.398 47.906 20.2491 47.9041 17.599ZM35.1295 17.599V4.79902C35.1315 2.15291 32.9884 0.00391437 30.3403 0C27.6922 0.00195719 25.5472 2.15095 25.5491 4.79902V17.599C25.5452 20.2471 27.6903 22.3961 30.3383 22.4C32.9864 22.398 35.1315 20.2491 35.1295 17.599Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3383 48C32.9864 47.998 35.1315 45.8491 35.1295 43.201C35.1315 40.5529 32.9864 38.4039 30.3383 38.402H25.5472V43.201C25.5452 45.8471 27.6903 47.9961 30.3383 48ZM30.3383 35.198H43.1129C45.761 35.1961 47.9061 33.0471 47.9041 30.399C47.908 27.7509 45.7629 25.602 43.1149 25.598H30.3403C27.6922 25.6 25.5472 27.749 25.5491 30.3971C25.5472 33.0471 27.6903 35.1961 30.3383 35.198Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33825e-06 30.399C-0.00195585 33.0471 2.14312 35.1961 4.79119 35.198C7.43927 35.1961 9.58434 33.0471 9.58239 30.399V25.6H4.79119C2.14312 25.602 -0.00195585 27.7509 1.33825e-06 30.399ZM12.7746 30.399V43.199C12.7706 45.8471 14.9157 47.9961 17.5638 48C20.2119 47.998 22.3569 45.8491 22.355 43.201V30.4029C22.3589 27.7549 20.2138 25.6059 17.5658 25.602C14.9157 25.602 12.7726 27.7509 12.7746 30.399Z",
    fill: "#E01E5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2291_2262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/Slack.f2750c2d529f6ef9436c46798598a5f6.svg";
export { ForwardRef as ReactComponent };